<template>
  <div v-if="$ability.can('read', 'CashFlow')">
    <div class="p-col-12" style="width: 100%; padding: 0">
      <CashFlowTabs></CashFlowTabs>
    </div>
    <div
      class="p-col-12"
      style="width: 100%; padding-left: 0; padding-right: 0"
    >
      <CashFlowSummary :values="summary" :loading="loading" />
    </div>
    <div v-if="loading">
      <div class="p-grid" id="loading">
        <div class="p-col-12" v-for="index in results.length || 5" :key="index">
          <Card>
            <template v-slot:content>
              <div class="p-grid">
                <div class="p-col-2" v-for="index in 12" :key="index">
                  <Skeleton width="100%" height="23px" />
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </div>
    <div
      v-else
      class="p-grid"
      v-for="transaction in results"
      :key="transaction.id"
    >
      <div class="p-col-12">
        <router-link
          v-if="$ability.can('write', 'CashFlow')"
          :to="{ name: 'cashflow.edit', params: { id: transaction.id } }"
          style="text-decoration: none"
        >
          <CashFlowCard :transaction="transaction" />
        </router-link>
        <CashFlowCard v-else :transaction="transaction" />
      </div>
    </div>
    <Paginator
      ref="paginator"
      :rows="query.pageSize"
      :rowsPerPageOptions="[20, 30, 40, 50]"
      :totalRecords="pagination.total"
      @page="onPageChange"
    ></Paginator>
    <router-link
      :to="{ name: 'cashflow.create' }"
      style="text-decoration: none"
      v-if="$ability.can('write', 'CashFlow')"
    >
      <AppFloatButton icon="pi pi-plus" />
    </router-link>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import { CashFlowTransactionApi } from '../../services/api';
import CashFlowCard from './components/CashFlowCard';
import CashFlowTabs from './components/CashFlowTabs.vue';
import CashFlowSummary from './components/CashFlowSummary.vue';

export default {
  components: {
    CashFlowCard,
    CashFlowSummary,
    CashFlowTabs,
  },
  data() {
    return {
      loading: false,
      query: {
        page: 1,
        pageSize: 20,
      },
      results: [],
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
      summary: {
        balance: 0,
        income: 0,
        expense: 0,
        profit: 0,
      },
    };
  },
  async created() {
    await this.fetchResults();
    this.$emitter.on('topbar-search', (event) => {
      this.query = {
        ...event.query,
        page: this.query.page,
        pageSize: this.query.pageSize,
      };
      this.fetchResults();
    });
  },
  methods: {
    async fetchResults() {
      try {
        this.loading = true;
        const [fetchResponse, fetchSummaryResponse] = await Promise.all([
          CashFlowTransactionApi.fetch(this.query),
          CashFlowTransactionApi.fetchSummary(this.query),
        ]);
        this.results = fetchResponse.results;
        this.pagination = fetchResponse.pagination;
        this.summary = fetchSummaryResponse;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange({ page, rows }) {
      this.query = {
        ...this.query,
        page: page + 1,
        pageSize: rows,
      };
      await this.fetchResults();
    },
  },
  beforeUnmount() {
    this.$emitter.off('topbar-search');
  },
};
</script>

<style lang="css" scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>